import script from "./count2.vue?vue&type=script&setup=true&lang=js"
export * from "./count2.vue?vue&type=script&setup=true&lang=js"

import "./count2.vue?vue&type=style&index=0&id=e46a1948&lang=scss"

const __exports__ = script;

export default __exports__